import React from "react";
import { Link } from 'react-scroll';

class Header extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            showMenu: 'none',
        }
    }

    setShowMenu(){
        this.setState({showMenu: this.state.showMenu === 'none' ? 'block' : 'none'})
    }

    render() {
        return (
            <React.Fragment>
                <header className="header" id="home">
                    <nav className="navbar navbar-expand-lg fixed-top">
                        <div className="container">
                            <a href="https://www.anthemav.com/">
                                <img src="img/anthem_horizontal_logo_white_red.png" alt="logo" width="250px" className="img-fluid" />
                            </a>
                            <button className="navbar-toggler" type="button" onClick={() => this.setShowMenu()}>
                                <img src="img/menu.svg" alt="Menu Icon"/>
                            </button>

                            <div className="collapse navbar-collapse h-auto" id="navbarSupportedContent" style={{display: this.state.showMenu}}>
                                <ul className="navbar-nav ml-auto menu">
                                    <li><Link to="home" smooth={true} duration={500} className="page-scroll">HOME</Link></li>
                                    <li><Link to="features" smooth={true} duration={500} className="page-scroll">FEATURES</Link></li>
                                    <li><Link to="downloads" smooth={true} duration={500} className="page-scroll">DOWNLOADS</Link></li>
                                    <li><Link to="compatibility" smooth={true} duration={500} className="page-scroll">COMPATIBILITY</Link></li>
                                    {/* <li><Link to="instructions" smooth={true} duration={500} className="page-scroll">INSTRUCTIONS</Link></li> */}
                                </ul>
                            </div>
                        </div>
                    </nav>
                </header>
            </React.Fragment>
        );
    }
}

export default Header;
